import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// 🔹 Get all free mock test submissions
export const getAllFreeMockTest = createAsyncThunk(
  "admin/allFreeMockTest",
  async ({ page = 1, limit = 10, searchData = "", startDate = "", endDate = "" }, { rejectWithValue }) => {
    try {
      let url = `/free-mock-test/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${encodeURIComponent(searchData)}`;
      }
      if (startDate && endDate) {
        url += `&startDate=${startDate}&endDate=${endDate}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Get single free mock test submission by id
export const getSingleFreeMockTest = createAsyncThunk(
  "admin/singleFreeMockTest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/free-mock-test/${id}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Delete free mock test entry (soft delete)
export const deleteFreeMockTest = createAsyncThunk(
  "admin/deleteFreeMockTest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/free-mock-test/delete/${id}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  freeMockTestData: null,
  singleFreeMockTest: {},
  freeMockTestLoading: false,
};

const freeMockTestSlice = createSlice({
  name: "freeMockTestSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllFreeMockTest.pending, (state) => {
        state.freeMockTestLoading = true;
      })
      .addCase(getAllFreeMockTest.fulfilled, (state, action) => {
        state.freeMockTestData = action.payload?.data;
        state.freeMockTestLoading = false;
      })
      .addCase(getAllFreeMockTest.rejected, (state) => {
        state.freeMockTestLoading = false;
      })
      .addCase(getSingleFreeMockTest.fulfilled, (state, action) => {
        state.singleFreeMockTest = action.payload?.data;
      })
      .addCase(deleteFreeMockTest.fulfilled, (state) => {
        state.freeMockTestLoading = false;
      });
  },
});

export default freeMockTestSlice.reducer;
